import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';

import moment from 'moment';

import { AppLayoutTop } from 'components/appComponents';
import { Button, DataGrid } from 'devextreme-react';
import { useQuery } from 'utils/useQuery';

import {
  useGetDriverPumpSalaryDetailsQuery,
  useLazyGetDriverPumpSalaryDetailsQuery,
} from 'bus/driverPumpMixerSalary/driverPumpMixerSalary';
import { useLazyGetEmployeeDetailQuery } from 'bus/employee/services/services';
import { EmployeeItem } from 'bus/employee/types';

import { SalaryDriversInfo, SalaryDriversInfoTotals } from './components';
import { onExporting } from './utils';

const SalaryPumpDriversInfo: FC = () => {
  const refGridMain = useRef<DataGrid | null>(null);
  const refGridAdjustment = useRef<DataGrid | null>(null);

  let { id } = useParams<{ id: string }>();
  let query = useQuery();

  const [fetchEmployeeDetail] = useLazyGetEmployeeDetailQuery();

  const dateBegin = query.get('dateBegin');
  const dateEnd = query.get('dateEnd');

  const [formEmployee, setFormEmployee] = useState<EmployeeItem | null>(null);

  const fullName = `${formEmployee?.name} ${formEmployee?.middleName} ${formEmployee?.surname}`;
  const dateBeginText = moment(dateBegin).format('DD.MM.YYYY');
  const dateEndText = moment(dateEnd).format('DD.MM.YYYY');
  const date = `${dateBeginText} - ${dateEndText}`;

  const [getDriverPumpSalaryDetails, { data }] = useLazyGetDriverPumpSalaryDetailsQuery();

  const { data: driverPumpSalary } = useGetDriverPumpSalaryDetailsQuery({
    driverId: +id,
    dateBegin: String(dateBegin),
    dateEnd: String(dateEnd),
  });

  const getDetail = useCallback(async () => {
    getDriverPumpSalaryDetails({
      driverId: +id,
      dateBegin: String(dateBegin),
      dateEnd: String(dateEnd),
    });
  }, [dateBegin, dateEnd, getDriverPumpSalaryDetails, id]);

  const getEmployeeDetail = useCallback(async () => {
    await fetchEmployeeDetail({ id })
      .unwrap()
      .then((data) => {
        setFormEmployee({ ...data });
      });
  }, [fetchEmployeeDetail, id]);

  useEffect(() => {
    getDetail();
    getEmployeeDetail();
  }, [getDetail, getEmployeeDetail]);

  const exportGrids = () => {
    if (!driverPumpSalary) return;
    onExporting(refGridMain, refGridAdjustment, driverPumpSalary, fullName, {
      dateBeginText,
      dateEndText,
    });
  };

  const refresh = useCallback(() => {
    getDetail();
    getEmployeeDetail();
  }, [getDetail, getEmployeeDetail]);

  return (
    <div>
      <AppLayoutTop title={`${fullName} (${date})`}>
        <Button className="send mr-2" icon="refresh" onClick={refresh} />
        <Button text="Экспорт в excel" icon="xlsxfile" onClick={exportGrids} />
      </AppLayoutTop>
      <SalaryDriversInfoTotals
        adjustments={driverPumpSalary?.adjustments || 0}
        balance={driverPumpSalary?.balance || 0}
        dateBegin={moment(dateBegin).format('DD.MM.YYYY') || ''}
        dateEnd={moment(dateEnd).format('DD.MM.YYYY') || ''}
        outBalance={driverPumpSalary?.outBalance || 0}
        pay={driverPumpSalary?.pay || 0}
        toPay={driverPumpSalary?.toPay || 0}
      />

      <SalaryDriversInfo ref={refGridMain} driverPumpSalary={data} />
    </div>
  );
};

export default SalaryPumpDriversInfo;
